import { FeaturePreviewExecutionHandler, type FeaturePreviewExecutionInput, type FeaturePreviewExecutionResult } from './FeaturePreviewExecutionHandler';

/**
 * 特征预览执行注册表。
 */
export class FeaturePreviewExecutionRegistry {
    /** 已注册处理器。 */
    private readonly handlers: FeaturePreviewExecutionHandler[] = [];

    /**
     * @param handlers 初始处理器集合。
     */
    public constructor(handlers: FeaturePreviewExecutionHandler[] = []) {
        this.registerMany(handlers);
    }

    /**
     * 注册处理器。
     *
     * @param handler 处理器。
     * @returns 当前注册表。
     */
    public register(handler: FeaturePreviewExecutionHandler): this {
        this.handlers.push(handler);
        return this;
    }

    /**
     * 批量注册处理器。
     *
     * @param handlers 处理器集合。
     * @returns 当前注册表。
     */
    public registerMany(handlers: FeaturePreviewExecutionHandler[]): this {
        handlers.forEach((handler) => {
            this.register(handler);
        });
        return this;
    }

    /**
     * 执行特征预览。
     *
     * @param input 预览输入。
     * @returns 预览结果。
     * @throws 当输入的特征类型没有注册公开预览处理器时。
     */
    public async execute(input: FeaturePreviewExecutionInput): Promise<FeaturePreviewExecutionResult> {
        for (const handler of this.handlers) {
            if (!handler.supports(input)) {
                continue;
            }
            return handler.execute(input);
        }
        throw new Error(`当前未实现该特征的公开预览执行入口：${input.featureKind}`);
    }
}
